import styled from 'styled-components';
import { StyledButton as Button } from '../CommonComponents/Button';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 71px);
`;

export const ControlsWrapper = styled.div`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  border: 1px solid #ebe7e7;
`;

export const EmptyStateWrapper = styled.div`
  background: #f9f7f7;
  overflow: hidden;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.26);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 30px 30px 0 30px;
`;

export const EmptyStateIllustration = styled.img`
  width: 120px;
  margin: 0 auto 30px auto;
`;

export const EmptyStateText = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.56;
  text-align: center;
  color: #6C727F;
  margin-bottom: 45px;
`;

export const AddButton = styled(Button.Primary)`
  border-radius: 3em;
  display: block;
  width: 100%;
  margin-bottom: 45px;
`;
